/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
        chartDict: {}
    },
    getters: {
        getChartDataByCode: (state, getters) => (code) => {
            return getters.chartDict[code];
        },
        chartDict: (state) => {
            return state.chartDict;
        },
    },
    mutations: {
        setChartDict(state, newValue) {
            Vue.set(state.chartDict, newValue.code, newValue.data,);
        }
    },
    actions: {
        async getChartGroup({ commit }, { data, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.category.chartGroup, data);
                handle && handle(rsp.data);
                console.log(rsp.data)
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },

        async getChartData({ commit }, { data, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.category.chartData, data);

                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryChartData({ commit }, { code, handle }) {
            let getData = { params: { gid: 1, chartTplCode: code, } };
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.get(ApiUrl.category.chartData, getData);
                let saveData = { code: code, data: rsp.data.message.data };
                commit('setChartDict', saveData);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async getReportData({ commit }, { data, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.category.reportData, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },

         async getReportVipcoms({ commit }, { data, handle }) {
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.category.reportVipcoms, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },




    }
}